/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeRosterStaffviewCtrl
 */
angular.module('mercury.modules.time.roster')
.controller('TimeRosterStaffviewCtrl', ["$q", "dialog", "$scope", "staff", "staffMemberDayData", "$state", "TimeStaff", "reporttime", "PayRules", "userinfo", "$filter", "shiftHelpers", function($q, dialog, $scope, staff, staffMemberDayData, $state, TimeStaff, reporttime, PayRules, userinfo, $filter, shiftHelpers) {
  $scope.member = staff;
  $scope.payRateReadOnly = true;
  $scope.loadingPackagesComplete = false;
  $scope.activePackages = [];

  if (userinfo.companyHasPermission('Payroll')) {
    $scope.loadingRules = PayRules.getAll();
    $scope.loadingRules.then(function(result) {
      $scope.activePackages = $filter('filter')(result, function(package) {
        return package.activation != null;
      });
      $scope.loadingPackagesComplete = true;
    });
  } else {
    $scope.loadingPackagesComplete = true;
  }

  var staffShifts = [];
  var totalHours = 0;
  var totalPay = 0;

  angular.forEach(staffMemberDayData, function(dayData) {
    angular.forEach(dayData.shifts, function(shift) {
      var shiftDay = moment(shift.clockinTime).mStartOf('day')
      shift.day = $scope.templateId ? shiftDay.format('dddd') : shiftDay.format('dddd, Do MMM');

      var startTime = moment(shift.clockinTime);
      var endTime = moment(shift.clockoutTime);

      // Calculate the total unpaid break duration using the helper function
      shift.totalUnpaidBreakHours = shiftHelpers.calculateTotalUnpaidBreakDuration(shift);

      // Calculate hours worked ensuring that unpaid break duration is removed from the total provided it is greater than the total unpaid break duration
      shift.time = (endTime.diff(startTime, 'minutes') / 60) > shift.totalUnpaidBreakHours ? (endTime.diff(startTime, 'minutes') / 60) - shift.totalUnpaidBreakHours : 0;
      shift.cost = shift.time * shift.adjustedHourlyRate;

      totalHours += shift.time;
      totalPay += shift.cost;
      staffShifts.push(shift);
    });
  });

  $scope.shifts = staffShifts;
  $scope.totalHours = totalHours;
  $scope.totalPay = totalPay;

  // Salaried staff members have their weekly total pay equal to the equivalent
  // of their 52 week annual salary. This means we can multiply by 52 to get
  // their annual salary. It also avoids any issues with calculating their rate
  // from remuneration history as this isn't correct if the roster being viewed
  // is locked - the shift rate is the source of truth in this scenario.
  $scope.annualSalary = totalPay * 52;

  // If the active remuneration is valid from the start of this week.
  if (staff.activeRemuneration && moment(staff.activeRemuneration.validFrom).isSame(moment(reporttime.start()))) {
    $scope.salaryPrevWeek = staff.previousRemuneration;
  }

  var nextWeekStart = moment(reporttime.start()).add(1, 'week');
  if (staff.nextRemuneration && moment(staff.nextRemuneration.validFrom).isSame(nextWeekStart)) {
    $scope.salaryNextWeek = staff.nextRemuneration;
  }

  /**
   * Save changes to a clockin to the server.
   */
  $scope.saveRoster = function() {
  };

  /**
   * Set the previous weeks remuneration to be effective this week by pushing the active remuneration forward a week.
   * If this conflicts with anther remuneration, we can just delete the active one.
   */
  $scope.overrideFromPrevious = function() {
    if ($scope.salaryNextWeek && moment($scope.salaryNextWeek.validFrom).isSame(moment(reporttime.end()))) {
      $scope.overriding = TimeStaff.deleteRemuneration(staff.activeRemuneration);
    } else {
      staff.activeRemuneration.validFrom = reporttime.end();
      $scope.overriding = TimeStaff.updateRemuneration(staff.activeRemuneration);
    }

    $scope.overriding.then(function() {
      // Reload the roster.
      dialog.close();
      $state.go($state.current.name, $state.params, {reload: true});
    });
  };

  /**
   * Set next week remuneration to be effective this week by updating its validFrom date.
   * If this conflits with the active remunerations validFrom, the active one will be deleted.
   */
  $scope.overrideFromNext = function() {
    $scope.salaryNextWeek.validFrom = reporttime.start();
    $scope.overriding = TimeStaff.updateRemuneration($scope.salaryNextWeek);
    $scope.overriding.then(function() {
      // Reload the roster.
      dialog.close();
      $state.go($state.current.name, $state.params, {reload: true});
    });
  };
}]);
